// @flow
import React, { Component } from "react";

import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import InputAdornment from "@material-ui/core/InputAdornment";

import type { ErrorsType } from "../../../account/types/UserFormType";
import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  ErrosDisplay,
  setErrorMsg
} from "../../../account/containers/ErrosDisplay";
import { StyledTextField, CancelButton, SubmitButton } from "imagus-components";

type CreateTierFormPropsType = {
  onClose: Function,
  tier?: { [key: string]: * },
  createTier: Function,
  updateTier: Function
};

type CreateTierFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  name: string,
  authorisedDistributer: string,
  authorisedReseller: string,
  standardDistributer: string,
  standardReseller: string
};

class CreateTierForm extends Component<
  CreateTierFormPropsType,
  CreateTierFormStatesType
> {
  constructor(props: CreateTierFormPropsType) {
    super(props);
    this.state = {
      errors: {},
      loading: false,
      name: "",
      authorisedDistributer: "",
      authorisedReseller: "",
      standardDistributer: "",
      standardReseller: ""
    };
  }

  componentDidMount() {
    let initials = { ...this.state };
    const tier = this.props.tier;
    if (tier) {
      initials.name = tier.name;
      initials.authorisedDistributer = tier.discounts.authorised.distributer;
      initials.authorisedReseller = tier.discounts.authorised.reseller;
      initials.standardDistributer = tier.discounts.standard.distributer;
      initials.standardReseller = tier.discounts.standard.reseller;
    }

    this.setState({ ...initials });
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      { [name]: value },
      (): * => {
        if (
          [
            "authorisedDistributer",
            "authorisedReseller",
            "standardDistributer",
            "standardReseller"
          ].includes(name)
        ) {
          if (parseInt(value) < 0 || parseInt(value) > 100) {
            this.setState({
              errors: setErrorMsg(
                this.state.errors,
                "form",
                "discount value should be from 0 to 100"
              )
            });
          } else {
            this.setState({
              errors: setErrorMsg(this.state.errors, "form", "", true)
            });
          }
        }
      }
    );
  };

  submit = (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();

    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));

      if (this.props.tier) {
        this.props.updateTier(
          this.props.tier.id,
          this.state.name,
          this.state.authorisedDistributer,
          this.state.authorisedReseller,
          this.state.standardDistributer,
          this.state.standardReseller,
          this.submitDone,
          this.submitFail
        );
      } else {
        this.props.createTier(
          this.state.name,
          this.state.authorisedDistributer,
          this.state.authorisedReseller,
          this.state.standardDistributer,
          this.state.standardReseller,
          this.submitDone,
          this.submitFail
        );
      }
    }
  };

  submitDone = () => {
    this.props.onClose();
  };

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  };

  render(): React$Element<*> {
    const { errors, loading } = this.state;

    return (
      <form
        onSubmit={(!this.state.loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <StyledTextField
                  isRequired={true}
                  label="Tier Name"
                  name="name"
                  value={this.state.name}
                  onChange={this.handleTextChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={12}>
                <Table className="app-table center light-border">
                  <TableBody>
                    <TableRow>
                      <TableCell padding="dense" rowSpan={4}>
                        Discounts
                      </TableCell>
                      <TableCell padding="dense" rowSpan={2}>
                        Authorised
                      </TableCell>
                      <TableCell padding="dense">Distributer</TableCell>
                      <TableCell padding="dense" className="border">
                        <StyledTextField
                          isRequired={true}
                          label=""
                          name="authorisedDistributer"
                          value={this.state.authorisedDistributer}
                          onChange={this.handleTextChange}
                          inpuType="number"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell padding="dense">Reseller</TableCell>
                      <TableCell padding="dense" className="border">
                        <StyledTextField
                          isRequired={true}
                          label=""
                          name="authorisedReseller"
                          value={this.state.authorisedReseller}
                          onChange={this.handleTextChange}
                          inpuType="number"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell padding="dense" rowSpan={2}>
                        Standard
                      </TableCell>
                      <TableCell padding="dense">Distributer</TableCell>
                      <TableCell padding="dense" className="border">
                        <StyledTextField
                          isRequired={true}
                          label=""
                          name="standardDistributer"
                          value={this.state.standardDistributer}
                          onChange={this.handleTextChange}
                          inpuType="number"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell padding="dense">Reseller</TableCell>
                      <TableCell padding="dense" className="border">
                        <StyledTextField
                          isRequired={true}
                          label=""
                          name="standardReseller"
                          value={this.state.standardReseller}
                          onChange={this.handleTextChange}
                          inpuType="number"
                          endAdornment={
                            <InputAdornment position="end">%</InputAdornment>
                          }
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <ErrosDisplay errors={this.state.errors} form="close project" />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <div className="form-right-btn-block">
                <CancelButton onClick={this.props.onClose} />
                <SubmitButton
                  loading={this.state.loading}
                  title="Submit"
                  disabled={Object.keys(this.state.errors).length > 0}
                />
              </div>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

export default CreateTierForm;
